import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { FilterBar } from 'components/molecules/filter-bar';
import { ProjectFinancialsContext } from 'contexts/project-financials';
import { projectFinancialsContractTypeToIconMap } from '../../utils/common';
import { FilterBarWithExtraPadding, NameCellWrapper } from '../common';
import { ProjectFinancialsGranularVisibility } from '../visibility-config';

interface Props {
  toggleVisibility: (key: string) => void;
}

export const ProjectFinancialsActionBar: FC<Props> = ({ toggleVisibility }) => {
  const context = useContext(ProjectFinancialsContext);
  const {
    projectFinancials: {
      projectFinancialDetails: { financialContractType },
    },
  } = context;

  return (
    <FilterBarWithExtraPadding>
      <FilterBar.Primary>
        <NameCellWrapper>
          {projectFinancialsContractTypeToIconMap[financialContractType]}
          <strong>
            <FormattedMessage
              id={`project.financials.type.${financialContractType}.title`}
            />
          </strong>
        </NameCellWrapper>
      </FilterBar.Primary>
      <FilterBar.Secondary>
        <ProjectFinancialsGranularVisibility
          toggleVisibility={toggleVisibility}
        />
      </FilterBar.Secondary>
    </FilterBarWithExtraPadding>
  );
};
